import { UserAction } from '@thoughtspot/metrics';
import { ButtonType } from '@thoughtspot/radiant-react/widgets/button/button';
import { ChipInputProps } from '@thoughtspot/radiant-react/widgets/chip/chip-input';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { RowDataProps } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Sharable } from '/@services/generated/graphql-types';
import {
    InviteSource,
    InviteUsersProps,
} from '../invite-users/invite-users.interface';

export enum InviteButtonState {
    INIT,
    BUTTON_CLICKED,
    CALL_NW,
    VALIDATE,
}

export interface InviteUsersContentV2Props {
    emailChips: ChipInputProps[];
    onRemoveUser: (userId: string) => void;
    comment: string;
    setComment: (comment: string) => void;
    onEnter: (event?: React.KeyboardEvent<HTMLElement>) => void;
    onBackspace: () => void;
    searchInput: string;
    setSearchInput: (input: string) => void;
    displayName: string;
    handleNameInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    validateEmail: (email: string) => void;
    chipBodyClicked: (userId: string) => void;
}
export interface UserEmailProps {
    emailId: string;
    hasError?: boolean;
    errorString?: string;
}
export interface ShareObjectProps {
    selectedSharableIds: string[];
    setSelectedSharableIds: (ids: string[]) => void;
    objectList: Sharable[];
    onDataSourceClicked: (datasourceIds: string[], liveboard: string) => void;
}

export interface ShareObjectsContainerProps extends ShareObjectProps {
    isShareModalOpen: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
    isLoading: boolean;
    errorMsg: string;
    isAlertBannerVisible: boolean;
    setIsAlertBannerVisible: () => void;
}

export interface UnderlyingDataSourcesProps {
    pinboardName: string;
    data: RowDataProps[];
}

export interface HeaderComponentProps {
    headerName: string;
}

export interface UnderlyingDataSourcesContainerProps {
    pinboardName: string;
    isDataSourceModalOpen: boolean;
    dataSourceIDs: string[];
    onConfirm: () => void;
}

export interface InviteUserContentV2ContainerProps {
    isModalOpen: boolean;
    onConfirm: () => void;
    isLoading: boolean;
    onDismiss: () => void;
    emailChips: ChipInputProps[];
    setEmailChips: (chips: ChipInputProps[]) => void;
    sharables: Sharable[];
    comment: string;
    setComment: (comment: string) => void;
    errorMsg: string;
    isAlertBannerVisible: boolean;
    setIsAlertBannerVisible: () => void;
    displayName: string;
    handleNameInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isShareStepEnabled: boolean;
}

export interface InviteUsersV2ContainerProps {
    onModalCloseCb: () => void;
    setIsToastVisible: () => void;
    isShareStepEnabled: boolean;
    source: InviteSource;
}

export type InviteUsersModalV2ContainerProps = InviteUsersV2ContainerProps;

export interface InviteUsersButtonProps extends InviteUsersProps {
    // button text for example Invite Others/ Invite teammates.
    buttonText?: string;
    // Invite button icon.
    buttonIcon?: IconID;
    // if true then button property isFullWidth is set to true.
    isFullWidth?: boolean;
    // button type.
    buttonType?: ButtonType;
    // function to be executed when Invite button is clicked,
    // if true modal is opened on button click.
    buttonClickFn?: () => boolean;
    shouldCollectInviteBtnEvent?: boolean;
    onInviteBtnClickUserAction?: UserAction;
}
